import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useTranslation } from "react-i18next";
import { RequestFeedbackSettings } from "@/types/feedback-settings";

interface RequestFeedbackSettingsFormProps {
  settings: RequestFeedbackSettings;
  onSettingsChange: (settings: RequestFeedbackSettings) => void;
}

export const RequestFeedbackSettingsForm = ({
  settings,
  onSettingsChange,
}: RequestFeedbackSettingsFormProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <Label className="flex items-start gap-3">
        <Switch
          checked={settings.enabled}
          onCheckedChange={(enabled) =>
            onSettingsChange({
              ...settings,
              enabled,
            })
          }
        />
        <div className="flex flex-col gap-1">
          <span className="text-base font-medium">
            {t("feedbacks.settings.requests.enabled")}
          </span>
        </div>
      </Label>

      <Label className="flex items-start gap-3">
        <Switch
          checked={settings.allowComment}
          onCheckedChange={(allowComment) =>
            onSettingsChange({
              ...settings,
              allowComment,
            })
          }
        />
        <div className="flex flex-col gap-1">
          <span className="text-base font-medium">
            {t("feedbacks.settings.requests.allowComment")}
          </span>
          <span className="text-sm text-muted-foreground">
            {t("feedbacks.settings.requests.allowCommentHint")}
          </span>
        </div>
      </Label>
    </div>
  );
};
